import Container from "@mui/material/Container"; // Local CUSTOM COMPONENTS

import ProductTabs from "./product-tabs";
import ProductIntro from "./product-intro";
import React from "react";
import RelatedProducts from "./related-products";
import FrequentlyBought from "./frequently-bought"; // CUSTOM DATA MODEL
import { Product } from "src/lib/fetcher/client";
import { StyledCard } from "./styles";
import Grid from "@mui/material/Grid";
import BrandSection from "./brand";

// ==============================================================
const ProductDetailsPageView: React.FC<{
  product: Product;
  frequentlyBought: Product[];
  relatedProducts: Product[];
}> = (props) => {
  return (
    <Container sx={{ mb: 8 }}>
      <Grid container spacing={3} mt={1}>
        {/* PRODUCT DETAILS INFO AREA */}
        <Grid item md={12} xs={12}>
          <StyledCard>
            <ProductIntro product={props.product} brandName={props.product.brand?.name ?? ""} />
          </StyledCard>
        </Grid>
        {/* PRODUCT DESCRIPTION AND REVIEW */}
        <Grid item md={12} xs={12}>
          <StyledCard sx={{ flexDirection: "column" }}>
            <ProductTabs product={props.product} />
          </StyledCard>
        </Grid>

        {/* BRAND AREA */}
        <Grid item md={9} xs={12}>
          <StyledCard sx={{ flexDirection: "column" }}>
            <BrandSection brand={props.product.brand} />
          </StyledCard>
        </Grid>

        {/* FREQUENTLY BOUGHT PRODUCTS AREA */}
        <FrequentlyBought products={props.frequentlyBought} />

        {/* AVAILABLE SHOPS AREA */}
        {/* <AvailableShops shops={props.availableShops} /> */}

        {/* RELATED PRODUCTS AREA */}
        <Grid item md={3} xs={12}>
          <StyledCard sx={{ flexDirection: "column" }}>
            <RelatedProducts products={props.relatedProducts} />
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProductDetailsPageView;
